import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import ShippingAndTaxForm, {
    ShippingAndTaxFormProps
} from "../../../pages/program/shippingAndTax/components/ShippingAndTaxForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ShippingAndTaxFormProps {
}

type Props = OwnProps;

// @ts-ignore
const ShippingAndTaxModal = NiceModal.create<Props>(({shippingAndTax, equipment, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ShippingAndTaxForm shippingAndTax={shippingAndTax} equipment={equipment}/>
        </SlideOver>
    )
})

export default ShippingAndTaxModal;
